import { useQueryClient } from '@tanstack/react-query';
import { useApi } from '../../../context/ApiContext/useApi';
import { InvalidationTag, useAppMutation } from '../utils';
import { CreateCompanyActionRequest } from '../../../api/companyAction/companyAction.models';

export const useCreateCompanyAction = () => {
  const { companyActionApi } = useApi();
  const queryClient = useQueryClient();
  const mutation = useAppMutation(
    (req: CreateCompanyActionRequest) =>
      companyActionApi.createCompanyAction(req),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [InvalidationTag.CompanyAction],
        });
      },
    }
  );
  return mutation;
};
